import React from "react";
import { withTranslation } from "react-i18next";

import { Alert, Icon, Button } from "tabler-react";

function TelegramInstructions({ t, onConnectionComplete, isPolling }) {
    return (
        <Alert type="info" hasExtraSpace>
            <div className="d-flex align-items-start">
                <Icon name="info" className="text-info mr-3 mt-1" size="lg" />
                <div className="flex-fill">
                    <h5 className="mb-3">
                        {t("shop.account.telegram.instructions_title")}
                    </h5>

                    <div className="mb-3">
                        <p className="mb-2">
                            {t("shop.account.telegram.instructions_intro")}
                        </p>

                        <ol className="pl-3">
                            <li className="mb-2">
                                {t("shop.account.telegram.instruction_step_1")}
                            </li>
                            <li className="mb-2">
                                {t("shop.account.telegram.instruction_step_2")}
                            </li>
                            <li className="mb-2">
                                {t("shop.account.telegram.instruction_step_3")}
                            </li>
                            <li className="mb-2">
                                {t("shop.account.telegram.instruction_step_4")}
                            </li>
                        </ol>
                    </div>

                    {isPolling && (
                        <div className="d-flex align-items-center p-3 bg-light rounded">
                            <Icon name="clock" className="text-info mr-3" />
                            <div>
                                <strong>
                                    {t(
                                        "shop.account.telegram.waiting_for_connection",
                                    )}
                                </strong>
                                <div className="text-muted small">
                                    {t(
                                        "shop.account.telegram.waiting_description",
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mt-3 pt-3 border-top">
                        <h6 className="mb-2">
                            <Icon name="help-circle" className="mr-2" />
                            {t("shop.account.telegram.troubleshooting_title")}
                        </h6>
                        <ul className="list-unstyled text-muted small">
                            <li className="mb-1">
                                <Icon name="arrow-right" className="mr-2" />
                                {t(
                                    "shop.account.telegram.troubleshooting_step_1",
                                )}
                            </li>
                            <li className="mb-1">
                                <Icon name="arrow-right" className="mr-2" />
                                {t(
                                    "shop.account.telegram.troubleshooting_step_2",
                                )}
                            </li>
                            <li className="mb-1">
                                <Icon name="arrow-right" className="mr-2" />
                                {t(
                                    "shop.account.telegram.troubleshooting_step_3",
                                )}
                            </li>
                        </ul>
                    </div>

                    {onConnectionComplete && (
                        <div className="mt-3 pt-3 border-top">
                            <Button
                                color="secondary"
                                size="sm"
                                outline
                                onClick={onConnectionComplete}
                            >
                                {t("shop.account.telegram.cancel_connection")}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Alert>
    );
}

export default withTranslation()(TelegramInstructions);
